import React, { createContext, useContext, useState, useEffect } from 'react';

interface LivesContextType {
  lives: number;
  addLives: (amount: number) => void;
  resetLives: () => void;
}

const LivesContext = createContext<LivesContextType>({
  lives: 0,
  addLives: () => {},
  resetLives: () => {},
});

export const useLives = () => useContext(LivesContext);

export const LivesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lives, setLives] = useState<number>(0);

  // Load lives from localStorage on mount
  useEffect(() => {
    const savedLives = localStorage.getItem('userLives');
    if (savedLives) {
      const loadedLives = Math.min(5, parseInt(savedLives, 10)); // Cap at 5 lives maximum
      setLives(loadedLives);
      localStorage.setItem('userLives', loadedLives.toString()); // Update localStorage if capped
    }
  }, []);

  const addLives = (amount: number) => {
    setLives(currentLives => {
      const newLives = Math.max(0, Math.min(5, currentLives + amount)); // Cap at 5 lives maximum
      localStorage.setItem('userLives', newLives.toString());
      return newLives;
    });
  };

  const resetLives = () => {
    setLives(0);
    localStorage.removeItem('userLives');
  };

  return (
    <LivesContext.Provider value={{ lives, addLives, resetLives }}>
      {children}
    </LivesContext.Provider>
  );
}; 